async function get(authUrl, params, token, clientId) {
  const query = params ? new URLSearchParams(params).toString() : '';

  return await fetch(`${authUrl}/nlu/flows?${query}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
      'x-ebiai-account-id': clientId
    }
  });
}

export default async function getFlowsList(
  authUrl,
  params,
  token,
  clientId,
  message
) {
  const response = await get(authUrl, params, token, clientId);
  if (response.ok) {
    const responseVersion = await response.json();
    return responseVersion;
  }
  const error = await response.json();
  message.error(error.message);
}
